import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import {
  fetchSingleTicketAsync,
  fetchTicketRepliesAsync,
  replySupportTicketAsync,
  selectSingleTicket,
  selectSingleTicketLoading,
  selectTicketReplies,
  selectTicketRepliesLoading,
  selectReplyLoading,
} from "@/store/redux/slices/support/support_slice";

export const useSupportTicketChat = (ticketId) => {
  const dispatch = useDispatch();
  const ticket = useSelector(selectSingleTicket);
  const ticketReplies = useSelector(selectTicketReplies);
  const isLoading = useSelector(selectSingleTicketLoading);
  const repliesLoading = useSelector(selectTicketRepliesLoading);
  const replyLoading = useSelector(selectReplyLoading);

  const refetch = useCallback(async () => {
    if (!ticketId) return;

    await Promise.all([
      dispatch(fetchSingleTicketAsync({ key: "_id", value: ticketId })).unwrap(),
      dispatch(fetchTicketRepliesAsync({ ticketId })).unwrap(),
    ]);
  }, [dispatch, ticketId]);

  useEffect(() => {
    if (ticketId) {
      refetch();
    }
  }, [ticketId, refetch]);

  const sendReply = useCallback(
    async (message) => {
      if (!ticketId || !message?.trim()) return;

      const description = DOMPurify.sanitize(message, {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: [],
      }).trim();

      if (!description) return;

      await dispatch(
        replySupportTicketAsync({ supportTicketID: ticketId, description })
      ).unwrap();

      await dispatch(fetchTicketRepliesAsync({ ticketId })).unwrap();
    },
    [dispatch, ticketId]
  );

  return {
    ticket,
    ticketReplies,
    isLoading,
    repliesLoading,
    replyLoading,
    sendReply,
    refetch,
  };
};
